import { renderMarkdown } from '@/components/wikitext/wiki_text_markdown'
import { wikiToPlainText } from '@/util/tokenize_wiki_text'

const LABEL_TAGS = ['STRONG', 'B']
const ENDS_LIKE_A_SENTENCE = /[.?!]$/

function normalizedText(block: Element): string {
  return (block.textContent || '').replace(/\s+/g, ' ').trim()
}

function isBoldOnlyParagraph(block: Element): boolean {
  const onlyChild = block.children.length === 1 ? block.children[0] : null
  return block.tagName === 'P' && !!onlyChild && LABEL_TAGS.includes(onlyChild.tagName) &&
    onlyChild.textContent?.trim() === block.textContent?.trim()
}

function isSectionLabel(block: Element, hasFollowingBlock: boolean): boolean {
  return hasFollowingBlock && isBoldOnlyParagraph(block) && !ENDS_LIKE_A_SENTENCE.test(normalizedText(block))
}

export function goalPreviewText(goalText: string): string {
  const container = document.createElement('div')
  container.innerHTML = renderMarkdown(wikiToPlainText(goalText))
  const blocks = [...container.children]
  return blocks
    .map((block, index) => {
      const text = normalizedText(block)
      return isSectionLabel(block, index < blocks.length - 1) && !text.endsWith(':') ? `${text}:` : text
    })
    .filter(Boolean)
    .join(' ')
}
